import { useMemo, useState } from "react";

const API_BASE = "https://669b2fmgm3.execute-api.ap-south-1.amazonaws.com/prod";

const MEDIA = {
  topPerformer1: "https://craftingbrain-internship-media2.s3.ap-south-1.amazonaws.com/internship/top-performers/top-performer-1.JPG",
  topPerformer2: "https://craftingbrain-internship-media2.s3.ap-south-1.amazonaws.com/internship/top-performers/top-performer-2.JPG",
  testimonial1:  "https://craftingbrain-internship-media2.s3.ap-south-1.amazonaws.com/internship/testimonials/testimonial-1.mp4",
  testimonial2:  "https://craftingbrain-internship-media2.s3.ap-south-1.amazonaws.com/internship/testimonials/testimonial-2.mp4",
};

const WHATSAPP_LINK = "https://chat.whatsapp.com/HKSuDUfpusGAQRtoCetcTn?mode=gi_t";

const SKILL_OPTIONS = [
  "Python", "Machine Learning", "Data Analysis", "Deep Learning",
  "NLP / LLM", "Web Development", "SQL / Databases", "Computer Vision", "None yet",
];

export default function InternshipRegister() {
  const REGISTER_URL = useMemo(() => `${API_BASE}/internship/register`, []);

  const [form, setForm] = useState({
    name: "", phone: "", email: "", college: "",
    branch: "", year: "", city: "", mode: "online",
    python_level: "", background: "", heard_from: "", notes: "",
  });
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ok, setOk]     = useState(false);
  const [msg, setMsg]   = useState("");
  const [err, setErr]   = useState("");

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const toggleSkill = (skill) => {
    setSelectedSkills((prev) =>
      prev.includes(skill) ? prev.filter((s) => s !== skill) : [...prev, skill]
    );
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.python_level) { setErr("Please select your Python experience level."); return; }
    setLoading(true); setOk(false); setMsg(""); setErr("");
    try {
      const payload = {
        ...form,
        year: form.year ? Number(form.year) : null,
        skills: selectedSkills.join(", ") || "None",
      };
      const res  = await fetch(REGISTER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setErr(data?.message || "Registration failed. Please try again.");
      } else {
        setOk(true);
        setMsg(data?.message || "Registered successfully!");
        setForm({ name: "", phone: "", email: "", college: "", branch: "", year: "", city: "", mode: "online", python_level: "", background: "", heard_from: "", notes: "" });
        setSelectedSkills([]);
      }
    } catch {
      setErr("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const syllabus = [
    { day: "Day 1", title: "Python Refresher + Prompt Engineering", duration: "3 hrs" },
    { day: "Day 2", title: "Working with LLM APIs (Groq / Gemini / OpenAI)", duration: "3 hrs" },
    { day: "Day 3", title: "Build a Chatbot / AI Assistant from Scratch", duration: "3 hrs" },
    { day: "Day 4", title: "RAG — Make AI Answer from Your Own Docs", duration: "3 hrs" },
    { day: "Day 5", title: "Deploy + Demo Day + Industry Guest Session", duration: "4 hrs" },
  ];

  return (
    <div className="cb-wrap">

      {/* ── WHATSAPP FLOATING BUTTON ── */}
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="cb-wa-float"
        title="Join our WhatsApp Community"
      >
        <svg viewBox="0 0 32 32" className="cb-wa-icon" fill="currentColor">
          <path d="M16 2C8.268 2 2 8.268 2 16c0 2.492.648 4.832 1.782 6.865L2 30l7.335-1.762A13.928 13.928 0 0016 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.5a11.44 11.44 0 01-5.833-1.596l-.418-.248-4.352 1.045 1.082-4.233-.272-.435A11.453 11.453 0 014.5 16C4.5 9.649 9.649 4.5 16 4.5S27.5 9.649 27.5 16 22.351 27.5 16 27.5zm6.29-8.545c-.344-.172-2.036-1.004-2.352-1.118-.316-.115-.547-.172-.777.172-.23.344-.891 1.118-1.093 1.348-.201.23-.402.258-.746.086-.344-.172-1.452-.535-2.765-1.707-1.022-.912-1.712-2.037-1.913-2.381-.2-.344-.021-.53.15-.701.156-.155.344-.402.516-.603.172-.2.23-.344.344-.574.115-.23.058-.43-.029-.603-.086-.172-.777-1.873-1.064-2.563-.28-.672-.566-.581-.777-.592l-.66-.011c-.23 0-.603.086-.918.43-.316.344-1.207 1.18-1.207 2.876s1.236 3.337 1.408 3.567c.172.23 2.432 3.713 5.893 5.207.824.355 1.467.567 1.969.727.827.263 1.58.226 2.175.137.663-.099 2.036-.832 2.323-1.636.287-.803.287-1.492.2-1.636-.085-.143-.315-.23-.66-.402z"/>
        </svg>
        <span className="cb-wa-label">Join Community</span>
      </a>

      {/* ── HERO ── */}
      <section className="cb-hero">
        <div className="cb-hero-inner">
          <div className="cb-tag">CraftingBrain · Internship Drive 2026</div>
          <h1 className="cb-h1">
            Gen AI Developer<br /><span className="cb-accent">Internship Program</span>
          </h1>
          <p className="cb-lead">
            Build Real AI Products in 5 Days · Project-based · Mentor-guided ·{" "}
            <strong>Top Performer Selected Every Batch</strong>
          </p>
          <div className="cb-badges">
            {["100% Free", "Real Project", "Mentor Support", "Certificate", "Top Performer Award"].map((b) => (
              <span key={b} className="cb-badge">{b}</span>
            ))}
          </div>
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="cb-wa-hero-btn">
            <svg viewBox="0 0 32 32" width="18" height="18" fill="currentColor" style={{ flexShrink: 0 }}>
              <path d="M16 2C8.268 2 2 8.268 2 16c0 2.492.648 4.832 1.782 6.865L2 30l7.335-1.762A13.928 13.928 0 0016 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.5a11.44 11.44 0 01-5.833-1.596l-.418-.248-4.352 1.045 1.082-4.233-.272-.435A11.453 11.453 0 014.5 16C4.5 9.649 9.649 4.5 16 4.5S27.5 9.649 27.5 16 22.351 27.5 16 27.5zm6.29-8.545c-.344-.172-2.036-1.004-2.352-1.118-.316-.115-.547-.172-.777.172-.23.344-.891 1.118-1.093 1.348-.201.23-.402.258-.746.086-.344-.172-1.452-.535-2.765-1.707-1.022-.912-1.712-2.037-1.913-2.381-.2-.344-.021-.53.15-.701.156-.155.344-.402.516-.603.172-.2.23-.344.344-.574.115-.23.058-.43-.029-.603-.086-.172-.777-1.873-1.064-2.563-.28-.672-.566-.581-.777-.592l-.66-.011c-.23 0-.603.086-.918.43-.316.344-1.207 1.18-1.207 2.876s1.236 3.337 1.408 3.567c.172.23 2.432 3.713 5.893 5.207.824.355 1.467.567 1.969.727.827.263 1.58.226 2.175.137.663-.099 2.036-.832 2.323-1.636.287-.803.287-1.492.2-1.636-.085-.143-.315-.23-.66-.402z"/>
            </svg>
            Join our WhatsApp Community — Stay Updated
          </a>
        </div>
      </section>

      {/* ── SYLLABUS STRIP ── */}
      <section className="cb-syllabus-section">
        <div className="cb-syllabus-inner">
          <p className="cb-section-label" style={{ textAlign: "center", borderBottom: "none", marginBottom: 28 }}>
            5-Day Curriculum — Build with AI · Gen AI Developer Track
          </p>
          <div className="cb-syllabus-grid">
            {syllabus.map(({ day, title, duration }) => (
              <div key={day} className="cb-syllabus-card">
                <div className="cb-syllabus-day">{day}</div>
                <div className="cb-syllabus-title">{title}</div>
                <div className="cb-syllabus-duration">⏱ {duration}</div>
              </div>
            ))}
          </div>
          <p className="cb-syllabus-note">
            📍 Online via Zoom/Meet &nbsp;·&nbsp; Total Duration: <strong>16 hrs</strong> over 5 days &nbsp;·&nbsp; For CSE / IT / AI / DS students
          </p>
        </div>
      </section>

      {/* ── BODY ── */}
      <div className="cb-body">
        <div className="cb-grid">

          {/* LEFT — Info */}
          <div className="cb-info">
            <p className="cb-section-label">What You Get</p>

            {[
              { icon: "🎯", title: "100% Free", desc: "No fees whatsoever. Just bring your laptop and willingness to learn." },
              { icon: "💻", title: "Real Project", desc: "Work on an actual product from Day 1 — not just assignments." },
              { icon: "🧑‍🏫", title: "Mentor Support", desc: "Dedicated mentor guidance throughout all 5 days." },
              { icon: "📜", title: "Certificate", desc: "Official completion certificate issued to every participant." },
              { icon: "🏆", title: "Top Performer Recognition", desc: "One student from each batch is selected as the Top Performer and receives an exclusive certificate and Letter of Recommendation from CraftingBrain." },
            ].map(({ icon, title, desc }) => (
              <div key={title} className="cb-feature">
                <div className="cb-feature-icon">{icon}</div>
                <div>
                  <div className="cb-feature-title">{title}</div>
                  <div className="cb-feature-desc">{desc}</div>
                </div>
              </div>
            ))}

            <div className="cb-perks-box">
              <div className="cb-perks-title">🎁 Every Participant Gets</div>
              <ul className="cb-perks-list">
                <li>✅ Internship Completion Certificate</li>
                <li>✅ GitHub portfolio with 3 live AI projects</li>
                <li>✅ Deployed app with a public shareable link</li>
                <li>✅ LinkedIn post template to announce completion</li>
                <li>✅ Daily assignments + hands-on project tasks</li>
              </ul>
              <div className="cb-perks-title" style={{ marginTop: 14 }}>🥇 Top Performer (1 Student) Gets</div>
              <ul className="cb-perks-list">
                <li>🏅 Exclusive "Top Performer" Certificate</li>
                <li>📄 Letter of Recommendation from CraftingBrain</li>
                <li>🌟 Featured on CraftingBrain's social media</li>
              </ul>
            </div>

            <div className="cb-callout">
              📧 A confirmation email is sent to your inbox instantly after registration.
            </div>
          </div>

          {/* RIGHT — Form */}
          <div className="cb-form-card">
            <div className="cb-form-header">
              <h2 className="cb-form-title">Register Now</h2>
              <p className="cb-form-sub">Tell us a bit about yourself — helps us support you better during the program.</p>
            </div>

            <form onSubmit={onSubmit} className="cb-form">

              {/* ── SECTION: Basic Info ── */}
              <div className="cb-form-section-label">Basic Info</div>

              <div className="cb-row">
                <div className="cb-field">
                  <label>Full Name <span className="cb-req">*</span></label>
                  <input name="name" placeholder="Your full name" required value={form.name} onChange={onChange} />
                </div>
                <div className="cb-field">
                  <label>Phone <span className="cb-req">*</span></label>
                  <input name="phone" placeholder="10-digit number" required value={form.phone} onChange={onChange} inputMode="numeric" />
                </div>
              </div>

              <div className="cb-field">
                <label>Email <span className="cb-req">*</span></label>
                <input name="email" type="email" placeholder="you@example.com" required value={form.email} onChange={onChange} />
              </div>

              <div className="cb-row">
                <div className="cb-field">
                  <label>College</label>
                  <input name="college" placeholder="College name" value={form.college} onChange={onChange} />
                </div>
                <div className="cb-field">
                  <label>Branch</label>
                  <input name="branch" placeholder="CSE / IT / AI / DS" value={form.branch} onChange={onChange} />
                </div>
              </div>

              <div className="cb-row">
                <div className="cb-field">
                  <label>Graduation Year</label>
                  <input name="year" placeholder="e.g. 2026" value={form.year} onChange={onChange} inputMode="numeric" />
                </div>
                <div className="cb-field">
                  <label>City</label>
                  <input name="city" placeholder="Your city" value={form.city} onChange={onChange} />
                </div>
              </div>

              <div className="cb-field">
                <label>Preferred Mode</label>
                <select name="mode" value={form.mode} onChange={onChange}>
                  <option value="online">Online</option>
                  <option value="offline">Offline</option>
                  <option value="both">Flexible (Online / Offline)</option>
                </select>
              </div>

              {/* ── SECTION: Background & Skills ── */}
              <div className="cb-form-section-label" style={{ marginTop: 6 }}>Background &amp; Skills</div>

              <div className="cb-field">
                <label>Python Experience Level <span className="cb-req">*</span></label>
                <select name="python_level" value={form.python_level} onChange={onChange} required>
                  <option value="">Select your level</option>
                  <option value="none">No Python knowledge yet</option>
                  <option value="beginner">Beginner — I know basic syntax &amp; loops</option>
                  <option value="intermediate">Intermediate — I've built small projects</option>
                  <option value="advanced">Advanced — I'm comfortable with libraries &amp; APIs</option>
                </select>
              </div>

              <div className="cb-field">
                <label>Overall Background / Experience</label>
                <select name="background" value={form.background} onChange={onChange}>
                  <option value="">Select your background</option>
                  <option value="student_fresher">Student — No projects yet</option>
                  <option value="student_projects">Student — Built 1–2 personal projects</option>
                  <option value="student_internship">Student — Done an internship before</option>
                  <option value="working_professional">Working Professional</option>
                  <option value="career_switcher">Career Switcher — Moving into AI/Tech</option>
                </select>
              </div>

              <div className="cb-field">
                <label>Skills You're Aware Of <span className="cb-opt">(select all that apply)</span></label>
                <div className="cb-skill-pills">
                  {SKILL_OPTIONS.map((skill) => (
                    <button
                      key={skill}
                      type="button"
                      className={`cb-pill ${selectedSkills.includes(skill) ? "cb-pill-active" : ""}`}
                      onClick={() => toggleSkill(skill)}
                    >
                      {selectedSkills.includes(skill) ? "✓ " : ""}{skill}
                    </button>
                  ))}
                </div>
              </div>

              <div className="cb-field">
                <label>How did you hear about this?</label>
                <select name="heard_from" value={form.heard_from} onChange={onChange}>
                  <option value="">Select an option</option>
                  <option value="whatsapp">WhatsApp Group / Message</option>
                  <option value="linkedin">LinkedIn</option>
                  <option value="instagram">Instagram</option>
                  <option value="college_faculty">College / Faculty</option>
                  <option value="friend">Friend / Classmate</option>
                  <option value="craftingbrain_website">CraftingBrain Website</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="cb-field">
                <label>Anything else you'd like to share <span className="cb-opt">(optional)</span></label>
                <textarea name="notes" placeholder="Goals, questions, or anything on your mind..." rows={3} value={form.notes} onChange={onChange} />
              </div>

              <button className="cb-btn" disabled={loading}>
                {loading ? <><span className="cb-spin" /> Submitting…</> : "Register for Free →"}
              </button>

              {ok && (
                <div className="cb-alert cb-ok">
                  <div className="cb-alert-icon cb-ok-icon">✓</div>
                  <div>
                    <div className="cb-alert-title">You're registered!</div>
                    <div className="cb-alert-msg">{msg}</div>
                  </div>
                </div>
              )}

              {err && (
                <div className="cb-alert cb-err">
                  <div className="cb-alert-icon cb-err-icon">!</div>
                  <div>
                    <div className="cb-alert-title">Something went wrong</div>
                    <div className="cb-alert-msg">{err}</div>
                  </div>
                </div>
              )}

              <p className="cb-consent">
                By registering, you agree to be contacted regarding internship updates.
              </p>
            </form>
          </div>

        </div>
      </div>

      {/* ── GALLERY + REVIEWS ── */}
      <section className="cb-gallery-section">
        <div className="cb-gallery-inner">
          <p className="cb-section-label" style={{ textAlign: "center", borderBottom: "none", marginBottom: 6 }}>
            From Previous Batches
          </p>
          <h2 className="cb-gallery-heading">Real Students. Real Projects. Real Results.</h2>

          <div className="cb-media-grid">
            <div className="cb-media-card cb-media-top">
              <div className="cb-media-ribbon">🥇 Top Performer</div>
              <img src={MEDIA.topPerformer1} alt="Jan 2026 Batch Top Performer" className="cb-media-img" />
              <div className="cb-media-caption">Batch Jan 2026 · Top Performer</div>
            </div>

            <div className="cb-media-card cb-media-top">
              <div className="cb-media-ribbon">🥇 Top Performer</div>
              <img src={MEDIA.topPerformer2} alt="Feb 2026 Batch Top Performer" className="cb-media-img" />
              <div className="cb-media-caption">Batch Feb 2026 · Top Performer</div>
            </div>

            <div className="cb-media-card cb-media-video">
              <div className="cb-media-ribbon cb-ribbon-green">💬 Student Testimonial</div>
              <video src={MEDIA.testimonial1} controls className="cb-media-vid" />
              <div className="cb-media-caption">Testimonial — Jan 2026 Batch</div>
            </div>

            <div className="cb-media-card cb-media-video">
              <div className="cb-media-ribbon cb-ribbon-green">💬 Student Testimonial</div>
              <video src={MEDIA.testimonial2} controls className="cb-media-vid" />
              <div className="cb-media-caption">Testimonial — Feb 2026 Batch</div>
            </div>
          </div>

          <div className="cb-wa-banner">
            <div className="cb-wa-banner-left">
              <div className="cb-wa-banner-title">📣 Join 500+ students in our AI Community</div>
              <div className="cb-wa-banner-sub">Get internship updates, resources, and early access — straight on WhatsApp.</div>
            </div>
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="cb-wa-banner-btn">
              <svg viewBox="0 0 32 32" width="18" height="18" fill="currentColor" style={{ flexShrink: 0 }}>
                <path d="M16 2C8.268 2 2 8.268 2 16c0 2.492.648 4.832 1.782 6.865L2 30l7.335-1.762A13.928 13.928 0 0016 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.5a11.44 11.44 0 01-5.833-1.596l-.418-.248-4.352 1.045 1.082-4.233-.272-.435A11.453 11.453 0 014.5 16C4.5 9.649 9.649 4.5 16 4.5S27.5 9.649 27.5 16 22.351 27.5 16 27.5zm6.29-8.545c-.344-.172-2.036-1.004-2.352-1.118-.316-.115-.547-.172-.777.172-.23.344-.891 1.118-1.093 1.348-.201.23-.402.258-.746.086-.344-.172-1.452-.535-2.765-1.707-1.022-.912-1.712-2.037-1.913-2.381-.2-.344-.021-.53.15-.701.156-.155.344-.402.516-.603.172-.2.23-.344.344-.574.115-.23.058-.43-.029-.603-.086-.172-.777-1.873-1.064-2.563-.28-.672-.566-.581-.777-.592l-.66-.011c-.23 0-.603.086-.918.43-.316.344-1.207 1.18-1.207 2.876s1.236 3.337 1.408 3.567c.172.23 2.432 3.713 5.893 5.207.824.355 1.467.567 1.969.727.827.263 1.58.226 2.175.137.663-.099 2.036-.832 2.323-1.636.287-.803.287-1.492.2-1.636-.085-.143-.315-.23-.66-.402z"/>
              </svg>
              Join WhatsApp Group →
            </a>
          </div>
        </div>
      </section>

      <style>{`
        .cb-wrap {
          min-height: 100vh;
          background: #f5f4f0;
          color: #111;
          font-family: 'Georgia', 'Times New Roman', serif;
        }

        /* ── WHATSAPP FLOAT ── */
        .cb-wa-float {
          position: fixed;
          bottom: 24px; right: 24px;
          z-index: 999;
          background: #25D366;
          color: #fff;
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 12px 18px;
          border-radius: 50px;
          text-decoration: none;
          font-size: 13.5px;
          font-weight: 700;
          font-family: ui-sans-serif, system-ui, sans-serif;
          box-shadow: 0 4px 20px rgba(37,211,102,.45);
          transition: transform .15s, box-shadow .15s;
        }
        .cb-wa-float:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(37,211,102,.55); }
        .cb-wa-icon { width: 20px; height: 20px; flex-shrink: 0; }
        .cb-wa-label { font-family: ui-sans-serif, system-ui, sans-serif; }

        /* ── HERO ── */
        .cb-hero {
          background: #111;
          padding: 64px 24px 52px;
          position: relative;
          overflow: hidden;
        }
        .cb-hero::before {
          content: '';
          position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 600px 280px at 10% 60%, rgba(247,198,0,.15), transparent),
            radial-gradient(ellipse 400px 350px at 90% 15%, rgba(247,198,0,.08), transparent);
          pointer-events: none;
        }
        .cb-hero-inner {
          max-width: 860px;
          margin: 0 auto;
          text-align: center;
          position: relative;
          z-index: 1;
        }
        .cb-tag {
          display: inline-block;
          background: rgba(247,198,0,.1);
          border: 1px solid rgba(247,198,0,.25);
          color: #f7c600;
          font-size: 11px;
          font-family: 'Courier New', monospace;
          letter-spacing: 2px;
          text-transform: uppercase;
          padding: 6px 16px;
          border-radius: 3px;
          margin-bottom: 22px;
        }
        .cb-h1 {
          font-size: clamp(34px, 5.5vw, 62px);
          font-weight: 900;
          color: #fff;
          margin: 0 0 16px;
          line-height: 1.08;
          letter-spacing: -1.5px;
        }
        .cb-accent { color: #f7c600; }
        .cb-lead {
          font-size: 15px;
          color: rgba(255,255,255,.55);
          margin: 0 0 30px;
          line-height: 1.65;
          font-style: italic;
        }
        .cb-lead strong { color: #f7c600; font-style: normal; font-weight: 700; }
        .cb-badges {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          justify-content: center;
          margin-bottom: 28px;
        }
        .cb-badge {
          background: rgba(255,255,255,.05);
          border: 1px solid rgba(255,255,255,.1);
          color: rgba(255,255,255,.6);
          font-size: 11.5px;
          font-family: 'Courier New', monospace;
          padding: 5px 14px;
          border-radius: 3px;
          letter-spacing: .5px;
        }
        .cb-wa-hero-btn {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          background: #25D366;
          color: #fff;
          text-decoration: none;
          font-size: 14px;
          font-weight: 700;
          font-family: ui-sans-serif, system-ui, sans-serif;
          padding: 12px 24px;
          border-radius: 50px;
          transition: transform .15s, filter .15s;
          box-shadow: 0 4px 18px rgba(37,211,102,.35);
        }
        .cb-wa-hero-btn:hover { transform: translateY(-2px); filter: brightness(1.07); }

        /* ── SYLLABUS ── */
        .cb-syllabus-section {
          background: #fff;
          border-bottom: 1px solid #e8e5de;
          padding: 44px 24px;
        }
        .cb-syllabus-inner { max-width: 1080px; margin: 0 auto; }
        .cb-syllabus-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 14px;
        }
        .cb-syllabus-card {
          background: #f9f8f4;
          border: 1px solid #e5e2d8;
          border-radius: 10px;
          padding: 18px 16px;
          transition: box-shadow .15s, transform .15s;
        }
        .cb-syllabus-card:hover { box-shadow: 0 4px 18px rgba(0,0,0,.08); transform: translateY(-2px); }
        .cb-syllabus-day {
          font-size: 10px;
          font-family: 'Courier New', monospace;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          color: #f7c600;
          background: #111;
          display: inline-block;
          padding: 3px 9px;
          border-radius: 3px;
          margin-bottom: 10px;
          font-weight: 700;
        }
        .cb-syllabus-title {
          font-size: 13px;
          font-weight: 700;
          color: #111;
          line-height: 1.45;
          font-family: ui-sans-serif, system-ui, sans-serif;
          margin-bottom: 8px;
        }
        .cb-syllabus-duration { font-size: 11.5px; color: #999; font-family: 'Courier New', monospace; }
        .cb-syllabus-note {
          text-align: center;
          font-size: 12.5px;
          color: #888;
          margin-top: 22px;
          font-family: ui-sans-serif, system-ui, sans-serif;
          font-style: italic;
        }
        .cb-syllabus-note strong { color: #111; font-style: normal; }

        /* ── GALLERY SECTION ── */
        .cb-gallery-section {
          background: #f5f4f0;
          padding: 52px 24px;
          border-bottom: 1px solid #e8e5de;
        }
        .cb-gallery-inner { max-width: 1080px; margin: 0 auto; }
        .cb-gallery-heading {
          font-size: clamp(22px, 3vw, 34px);
          font-weight: 900;
          color: #111;
          text-align: center;
          margin: 0 0 36px;
          letter-spacing: -.5px;
        }
        .cb-media-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 40px;
        }
        .cb-media-video { grid-column: span 1; }
        .cb-media-card {
          background: #fff;
          border: 1px solid #e0ddd6;
          border-radius: 12px;
          overflow: hidden;
          position: relative;
          box-shadow: 0 2px 12px rgba(0,0,0,.06);
          transition: transform .15s, box-shadow .15s;
        }
        .cb-media-card:hover { transform: translateY(-3px); box-shadow: 0 8px 24px rgba(0,0,0,.1); }
        .cb-media-ribbon {
          position: absolute;
          top: 10px; left: 10px;
          background: #111;
          color: #f7c600;
          font-size: 10.5px;
          font-family: 'Courier New', monospace;
          font-weight: 700;
          letter-spacing: 1px;
          padding: 4px 10px;
          border-radius: 4px;
          z-index: 2;
        }
        .cb-ribbon-green { background: #166534; color: #86efac; }
        .cb-media-img {
          width: 100%;
          aspect-ratio: 4/3;
          object-fit: cover;
          display: block;
        }
        .cb-media-vid {
          width: 100%;
          aspect-ratio: 16/9;
          display: block;
          background: #000;
        }
        .cb-media-caption {
          padding: 10px 12px;
          font-size: 11.5px;
          color: #888;
          font-family: ui-sans-serif, system-ui, sans-serif;
          font-style: italic;
          border-top: 1px solid #f0ede6;
        }

        /* WA Banner */
        .cb-wa-banner {
          background: #111;
          border-radius: 14px;
          padding: 22px 28px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          flex-wrap: wrap;
        }
        .cb-wa-banner-title {
          font-size: 15px;
          font-weight: 800;
          color: #fff;
          margin-bottom: 4px;
          font-family: ui-sans-serif, system-ui, sans-serif;
        }
        .cb-wa-banner-sub {
          font-size: 12.5px;
          color: rgba(255,255,255,.5);
          font-family: ui-sans-serif, system-ui, sans-serif;
        }
        .cb-wa-banner-btn {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          background: #25D366;
          color: #fff;
          text-decoration: none;
          font-size: 13.5px;
          font-weight: 800;
          font-family: ui-sans-serif, system-ui, sans-serif;
          padding: 12px 22px;
          border-radius: 50px;
          white-space: nowrap;
          transition: transform .15s, filter .15s;
          box-shadow: 0 4px 16px rgba(37,211,102,.3);
          flex-shrink: 0;
        }
        .cb-wa-banner-btn:hover { transform: translateY(-2px); filter: brightness(1.07); }

        /* ── BODY ── */
        .cb-body { max-width: 1080px; margin: 0 auto; padding: 52px 24px 80px; }
        .cb-grid { display: grid; grid-template-columns: 1fr; gap: 36px; }
        @media (min-width: 880px) {
          .cb-grid { grid-template-columns: 1fr 1.25fr; gap: 48px; align-items: start; }
        }
        .cb-section-label {
          font-size: 10.5px;
          font-family: 'Courier New', monospace;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          color: #999;
          margin: 0 0 20px;
          padding-bottom: 14px;
          border-bottom: 1px solid #e0ddd6;
        }
        .cb-feature {
          display: flex; gap: 16px;
          padding: 15px 0;
          border-bottom: 1px solid #ebe9e3;
          align-items: flex-start;
        }
        .cb-feature-icon { font-size: 21px; line-height: 1; flex-shrink: 0; margin-top: 1px; }
        .cb-feature-title {
          font-size: 14px; font-weight: 700; color: #111; margin-bottom: 3px;
          font-family: ui-sans-serif, system-ui, sans-serif;
        }
        .cb-feature-desc {
          font-size: 13px; color: #777; line-height: 1.55;
          font-family: ui-sans-serif, system-ui, sans-serif;
        }
        .cb-perks-box {
          margin-top: 22px;
          background: #111;
          border-radius: 10px;
          padding: 20px 22px;
          color: #fff;
        }
        .cb-perks-title {
          font-size: 12px;
          font-family: 'Courier New', monospace;
          letter-spacing: 1px;
          text-transform: uppercase;
          color: #f7c600;
          margin-bottom: 10px;
        }
        .cb-perks-list {
          list-style: none; margin: 0; padding: 0;
          display: flex; flex-direction: column; gap: 6px;
        }
        .cb-perks-list li {
          font-size: 13px; color: rgba(255,255,255,.75);
          font-family: ui-sans-serif, system-ui, sans-serif; line-height: 1.5;
        }
        .cb-callout {
          margin-top: 20px;
          background: #fffbe8;
          border: 1px solid #f0d060;
          border-left: 4px solid #f7c600;
          border-radius: 6px;
          padding: 13px 16px;
          font-size: 13px;
          color: #7a6500;
          font-family: ui-sans-serif, system-ui, sans-serif;
          line-height: 1.55;
        }

        /* ── FORM ── */
        .cb-form-card {
          background: #fff;
          border: 1px solid #ddd9d0;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 2px 16px rgba(0,0,0,.07), 0 8px 32px rgba(0,0,0,.04);
        }
        .cb-form-header { background: #111; padding: 22px 28px; }
        .cb-form-title { font-size: 19px; font-weight: 800; color: #fff; margin: 0 0 4px; letter-spacing: -.3px; }
        .cb-form-sub {
          font-size: 12.5px; color: rgba(255,255,255,.45); margin: 0;
          font-family: ui-sans-serif, system-ui, sans-serif; font-style: italic;
        }
        .cb-form { display: grid; gap: 14px; padding: 24px 28px 28px; }
        .cb-form-section-label {
          font-size: 9.5px;
          font-family: 'Courier New', monospace;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #bbb;
          background: #f9f8f4;
          border: 1px solid #ece9e2;
          border-radius: 5px;
          padding: 5px 10px;
          display: inline-block;
        }
        .cb-row { display: grid; gap: 14px; grid-template-columns: 1fr; }
        @media (min-width: 500px) { .cb-row { grid-template-columns: 1fr 1fr; } }
        .cb-field { display: flex; flex-direction: column; gap: 5px; }
        .cb-field label {
          font-size: 10.5px; font-family: 'Courier New', monospace;
          letter-spacing: 1px; text-transform: uppercase; color: #666;
        }
        .cb-req { color: #f7c600; }
        .cb-opt {
          color: #bbb; font-style: italic; text-transform: none;
          letter-spacing: 0; font-family: Georgia, serif; font-size: 10px;
        }
        .cb-field input, .cb-field select, .cb-field textarea {
          width: 100%; border: 1.5px solid #e0ddd6; border-radius: 7px;
          background: #fafaf7; color: #111; padding: 10px 12px; font-size: 14px;
          font-family: ui-sans-serif, system-ui, sans-serif; outline: none;
          transition: border-color .15s, box-shadow .15s, background .15s;
          box-sizing: border-box;
        }
        .cb-field input::placeholder, .cb-field textarea::placeholder { color: #c0bdb5; }
        .cb-field input:focus, .cb-field select:focus, .cb-field textarea:focus {
          border-color: #f7c600;
          box-shadow: 0 0 0 3px rgba(247,198,0,.18);
          background: #fff;
        }
        .cb-field textarea { resize: vertical; min-height: 78px; }

        /* ── SKILL PILLS ── */
        .cb-skill-pills {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 2px;
        }
        .cb-pill {
          background: #f5f4f0;
          border: 1.5px solid #e0ddd6;
          color: #555;
          font-size: 12px;
          font-family: ui-sans-serif, system-ui, sans-serif;
          font-weight: 500;
          padding: 6px 13px;
          border-radius: 20px;
          cursor: pointer;
          transition: all .15s;
          line-height: 1;
        }
        .cb-pill:hover { border-color: #f7c600; color: #111; background: #fffbe8; }
        .cb-pill-active {
          background: #111 !important;
          border-color: #111 !important;
          color: #f7c600 !important;
          font-weight: 700;
        }

        /* ── BUTTON & ALERTS ── */
        .cb-btn {
          width: 100%; height: 48px; background: #f7c600; color: #111;
          font-size: 14.5px; font-weight: 800;
          font-family: ui-sans-serif, system-ui, sans-serif;
          border: none; border-radius: 8px; cursor: pointer;
          display: flex; align-items: center; justify-content: center; gap: 10px;
          letter-spacing: .2px; margin-top: 4px;
          transition: transform .1s, filter .15s, opacity .15s;
        }
        .cb-btn:hover:not(:disabled) { filter: brightness(1.06); transform: translateY(-1px); }
        .cb-btn:active:not(:disabled) { transform: translateY(0); filter: brightness(.98); }
        .cb-btn:disabled { opacity: .6; cursor: not-allowed; }
        .cb-spin {
          width: 15px; height: 15px;
          border: 2px solid rgba(0,0,0,.18); border-top-color: #111;
          border-radius: 50%; animation: cbspin .7s linear infinite;
          display: inline-block; flex-shrink: 0;
        }
        @keyframes cbspin { to { transform: rotate(360deg); } }
        .cb-alert {
          display: flex; align-items: flex-start; gap: 12px;
          padding: 13px 16px; border-radius: 8px;
          font-family: ui-sans-serif, system-ui, sans-serif;
        }
        .cb-ok { background: #fffbea; border: 1px solid #f0d060; }
        .cb-err { background: #fff5f5; border: 1px solid #fca5a5; }
        .cb-alert-icon {
          width: 20px; height: 20px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 11px; font-weight: 900; flex-shrink: 0; margin-top: 2px;
        }
        .cb-ok-icon { background: #f7c600; color: #111; }
        .cb-err-icon { background: #ef4444; color: #fff; }
        .cb-alert-title { font-size: 13px; font-weight: 700; color: #111; margin-bottom: 2px; }
        .cb-alert-msg { font-size: 12.5px; color: #666; line-height: 1.5; }
        .cb-consent {
          font-size: 11px; color: #bbb; text-align: center; margin: 0;
          font-family: ui-sans-serif, system-ui, sans-serif; line-height: 1.5;
        }
      `}</style>
    </div>
  );
}
